import PathwayInviteCandidatesContainer from './pathway_invite_candidates_container';

const PathwayInviteCandidates = PathwayInviteCandidatesContainer;
export default PathwayInviteCandidates;
